import { VALIDATION } from '@/constants';

export const REDIRECT_PATH_KEY = 'evaltick_redirect_path';

export function saveRedirectPath(path: string): void {
  localStorage.setItem(REDIRECT_PATH_KEY, path);
}

export function getAndClearRedirectPath(): string | null {
  const path = localStorage.getItem(REDIRECT_PATH_KEY);
  if (path) {
    localStorage.removeItem(REDIRECT_PATH_KEY);
  }
  return path;
}

export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

export function validatePassword(password: string): PasswordValidationResult {
  const errors: string[] = [];

  if (password.length < VALIDATION.PASSWORD_MIN_LENGTH) {
    errors.push(`Password must be at least ${VALIDATION.PASSWORD_MIN_LENGTH} characters`);
  }

  if (password.length > VALIDATION.PASSWORD_MAX_LENGTH) {
    errors.push(`Password must be less than ${VALIDATION.PASSWORD_MAX_LENGTH} characters`);
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

export function validatePasswordsMatch(password: string, confirmPassword: string): boolean {
  return password === confirmPassword;
}

export function validateEmail(email: string): boolean {
  return VALIDATION.EMAIL_REGEX.test(email);
}

export function parseClerkError(error: unknown): string {
  if (error && typeof error === 'object') {
    const clerkError = error as {
      errors?: Array<{ message?: string; longMessage?: string; code?: string }>;
      message?: string;
    };

    if (clerkError.errors && clerkError.errors.length > 0) {
      const firstError = clerkError.errors[0];
      return firstError.longMessage || firstError.message || 'An error occurred';
    }

    if (clerkError.message) {
      return clerkError.message;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'An unexpected error occurred';
}

export function getClerkErrorCode(error: unknown): string | undefined {
  const clerkError = error as { errors?: Array<{ code?: string }> };
  return clerkError?.errors?.[0]?.code;
}
